import {Type} from 'main.core';

export class Tool
{
	constructor(options = {})
	{
		document.getElementById(options.SELECTOR).addEventListener('click', this.send)
	}

	send()
	{
		const {compare_checked, compare_url_add, compare_url_delete} = this.dataset;

		if(compare_checked){
			BX.ajax.get(compare_url_delete, () => {
				location.reload();
			});
		} else {
			BX.ajax.get(compare_url_add, () => {
				location.reload();
			});

		}
	}
}